// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4928 ? "e18fe737" : chunkId) + "." + {"4442":"2c36327d5dec1121","4928":"9adfd7f2dc74b381","5139":"76e28b326ce57f8d"}[chunkId] + ".js";
};